import React from "react";

import Line from "./shapes/Line";
import Rect from "./shapes/Rect";
import Ellipse from "./shapes/Ellipse";
import Text from "./shapes/Text";

class ShapeRenderer {
    constructor() {
        this.shape = null
        this.frame = null
        this.key = null
        this.filter = null
        this.addId = false
    }

    forShape(shape) {
        this.shape = shape
        return this
    }

    forFrame(frame) {
        this.frame = frame
        return this
    }
    
    withKey(key) {
        this.key = key
        return this
    }

    includeId() {
        this.addId = true
        return this
    }

    withFilter(filter) {
        this.filter = filter
        return this
    }

    render() {
        let shapeData = this.shape
        let filter = this.filter
        let key = this.key

        if (!shapeData || !shapeData.visible || (this.frame && shapeData.frame !== this.frame)) {
          return null
        }

        var {
            initCoords,
            finalCoords,
            borderColor,
            borderWidth,
            fillColor,
            fontSize,
            fontfamily,
            oldText,
            newText,
            id,
        } = shapeData;

        if (!this.addId) id = undefined

        switch (shapeData.type) {
          case "line": {
            return React.createElement(Line, {
              x1: initCoords.x,
              y1: initCoords.y,
              x2: finalCoords.x,
              y2: finalCoords.y,
              borderColor,
              borderWidth,
              id,
              key,
              filter,
            });
          }
          case "rect": {
            return React.createElement(Rect, {
              x: Math.min(initCoords.x, finalCoords.x),
              y: Math.min(initCoords.y, finalCoords.y),
              width: Math.abs(finalCoords.x - initCoords.x),
              height: Math.abs(finalCoords.y - initCoords.y),
              fillColor,
              borderColor,
              borderWidth,
              id,
              key,
              filter,
            });
          }
          case "ellipse": {
            let x = Math.min(finalCoords.x, initCoords.x);
            let y = Math.min(finalCoords.y, initCoords.y);
            let w = Math.abs(finalCoords.x - initCoords.x);
            let h = Math.abs(finalCoords.y - initCoords.y);
      
            return React.createElement(Ellipse, {
              cx: x + w / 2,
              cy: y + h / 2,
              rx: w / 2,
              ry: h / 2,
              fillColor,
              borderColor,
              borderWidth,
              id,
              key,
              filter,
            });
          }
          case "text": {
            return React.createElement(Text, {
              x: initCoords.x,
              y: initCoords.y,
              oldText,
              newText,
              fillColor,
              fontsize: fontSize,
              fontfamily: fontfamily,
              id,
              key,
              filter,
            });
          }
          default: {
            return null;
          }
        }
    }
}

export default ShapeRenderer